import { createSlice } from "@reduxjs/toolkit";
// ⚠️ Deep-imports the DESKTOP variant on purpose — hazard 6.
import { supportLogout, userLogout } from "../LoginSlice";
import { sharedInitialState, sharedReducers } from "./shared";
import type { SharedItemsState } from "./shared";

// `soldOutItemsList` moved to `shared.ts` on 2026-08-29 — mobile has it now too (hazard 38).
export interface ItemsState extends SharedItemsState {}

const initialState: ItemsState = {
  ...sharedInitialState,
};

export const itemsStatusSlice = createSlice({
  name: "itemStatus",
  initialState,
  reducers: {
    ...sharedReducers,
    // ⚠️ Diverges from mobile: web takes a payload here, mobile takes none. Keep the
    // `action` param even though the body is empty — dropping it would make RTK generate a
    // no-payload creator and break every `dispatch(getSoldOutItems(x))` on web.
    getSoldOutItems: (state, action) => {},
    // Web-only. (`getCurrentSoldOutItemSuccess` was the other one and is now shared.)
    updateItemStatusSlice: (state, action) => {
      return action.payload;
    }
  },
  // Both bodies are empty in the app source — the cases exist but reset nothing.
  extraReducers: (builder) => {
    builder
      .addCase(userLogout, (state) => {

      })
      .addCase(supportLogout, (state) => {

      });
  },
});

export const {
  getInStockItems,
  getInStockItemsSuccess,
  getSoldOutItems,
  getSoldOutItemsSuccess,
  prepareItems,
  prepareItemsSuccess,
  refreshItems,
  refreshItemsSuccess,
  emptyPrepareItemsResponse,
  emptyRefreshItemsResponse,
  updateItemStatusSlice,
  getCurrentSoldOutItemSuccess,
} = itemsStatusSlice.actions;
export default itemsStatusSlice.reducer;
